import {
    type CompRef,
    type ConversionAlgoConfigOverrides,
    MobileAlgoConditionType,
    type PS,
    type ResolvedFunctions
} from '@wix/document-services-types'
import {getReportableFromError, ReportableError} from '@wix/document-manager-utils'
import _ from 'lodash'

const MANUAL_EXECUTION_OPTIONS = {conditionType: MobileAlgoConditionType.Manual}

const createRunAsyncFunction =
    (path: string) =>
    async (
        ps: PS,
        compPointer: CompRef,
        resolvedFunctions?: ResolvedFunctions,
        conversionAlgoConfig?: ConversionAlgoConfigOverrides
    ) => {
        try {
            await _.get(ps.extensionAPI.mobileAlgo, path)(compPointer, conversionAlgoConfig, MANUAL_EXECUTION_OPTIONS)
            resolvedFunctions?.onSuccess()
            ps.setOperationsQueue.asyncPreDataManipulationComplete()
        } catch (e: any) {
            const newError = e?.errorType
                ? e
                : getReportableFromError(e, {
                      errorType: 'ResponsifyAlgorithmError'
                  })
            ps.setOperationsQueue.asyncPreDataManipulationComplete(null, newError as Error)
            ps.extensionAPI.logger.captureError(newError)
            resolvedFunctions?.onError()
        }
    }

const createLockingAsyncFunction = (path: string) => async (ps: PS, compPointer: CompRef) => {
    try {
        await _.get(ps.extensionAPI.mobileAlgo, path)(compPointer)
        ps.setOperationsQueue.asyncPreDataManipulationComplete()
    } catch (e: any) {
        const newError =
            e instanceof ReportableError
                ? e
                : getReportableFromError(e, {
                      errorType: 'ResponsifyAlgorithmError'
                  })
        ps.setOperationsQueue.asyncPreDataManipulationComplete(null, newError as Error)
        ps.extensionAPI.logger.captureError(newError)
    }
}

export default {
    runForPage: createRunAsyncFunction('runForPage'),
    run: createRunAsyncFunction('run'),
    locking: {
        softLock: createLockingAsyncFunction('locking.softLock'),
        softLockPage: createLockingAsyncFunction('locking.softLockPage')
    }
}
